import {AfterViewInit, Directive, ElementRef} from '@angular/core';

@Directive({
  selector: '[appClearHref]'
})
export class ClearHrefDirective implements AfterViewInit {

  constructor(
    public el: ElementRef,
  ) {}

  ngAfterViewInit() {
    const href = this.el.nativeElement.attributes.getNamedItem('href');
    if (href == null || href.value === '') {
      this.el.nativeElement.removeAttribute('href');
    }
  }
}
